import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { HashNavigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import AdaptiveButton from '../../components/AdaptiveButton';
import ButtonBar from '../../components/ButtonBar';
import ButtonToMenu from '../../components/ButtonToMenu';
import ContextualMenu from '../../components/ContextualMenu';
import AppConfig from '../../config';
import { t } from '../../lang';
import StorageService from '../../services/StorageService';
import { cardSlice } from '../../store/slices';
import CardPage from '../CardPage';
import Wallet from '../Wallet';

import 'swiper/css';
import 'swiper/css/pagination';
import './MainPage.scss';

const { routes, fiatCardsEnabled } = AppConfig;

const MainPage = () => {
	const cardsList = useSelector(state => state.card.cardsList);
	const availableCurrencies = useSelector(store => store.app.availableCurrencies);

	const dispatch = useDispatch();

	const navigate = useNavigate();

	const walletBalance = availableCurrencies.reduce((acc, currency) => acc + currency.AmountUsd, 0);

	useEffect(() => {
		if (fiatCardsEnabled) StorageService.UpdateCardList();
	}, []);

	const itemsMenu = [
		{
			className: 'MainPage__send-action-button',
			icon: 'ARROW_BOLD',
			content: () => t('Send'),
			onClick: () => {
				if (walletBalance) {
					navigate(routes.send);
				} else {
					navigate(
						{ pathname: routes.stubPage },
						{
							state: {
								header: 'Select asset to send',
								text: "You don't have any assets to send. Please top up your balance.",
								labelIcon: 'ARROW_CIRCLE',
							},
						}
					);
				}
			},
		},
		{
			className: 'MainPage__receive-action-button',
			icon: 'ARROW_BOLD',
			content: () => t('Receive'),
			onClick: () => navigate(routes.receiveAsset),
		},
		{
			icon: 'ARROW_TRIANGLEHEAD_SWAP_BOLD',
			content: () => t('Swap'),
			onClick: () =>
				navigate(
					{ pathname: routes.stubPage },
					{
						state: {
							header: 'Swap',
							text: 'Swap is currently unavailable, but we are working on getting it up and running',
							labelIcon: 'ARROW_TRIANGLEHEAD_SWAP_CIRCLE',
						},
					}
				),
			// separator: true,
		},
		{
			icon: 'AML_SCAN',
			content: () => t('AML check'),
			className: 'MainPage__ButtonBar-btn-aml',
			onClick: () => navigate({ pathname: routes.amlCheck }),
			separator: true,
		},
		{
			icon: 'PLUS_BOLD',
			content: () => t('Buy'),
			onClick: () =>
				navigate(
					{ pathname: routes.stubPage },
					{
						state: {
							header: 'Buy',
							text: 'Buy is currently unavailable, but we are working on getting it up and running.',
							labelIcon: 'PLUS_CIRCLE',
						},
					}
				),
		},
	];

	const openComponent = () => (
		<div>
			{itemsMenu.map((item, index) => (
				<ContextualMenu key={index} {...item} />
			))}
		</div>
	);

	const closeComponent = () => <AdaptiveButton icon='PLUS_BOLD' />;

	const goToAllWallets = () => {
		navigate(routes.allWallets);
	};

	const goToAllCards = () => {
		navigate(routes.allCards);
	};

	return (
		<div className='MainPage'>
			{cardsList ? (
				<Swiper
					hashNavigation={{ watchState: true, replaceState: true }}
					modules={[HashNavigation, Pagination]}
					pagination={{
						dynamicBullets: true,
						dynamicMainBullets: 5,
						el: '.MainPage__swiper-pagination',
					}}
					touchReleaseOnEdges={true}
					onSlideChange={swiper => {
						if (swiper.previousIndex) dispatch(cardSlice.actions.setViewedCardDetails());
					}}
				>
					<SwiperSlide data-hash={'wallet'} key={'wallet'}>
						<Wallet />
					</SwiperSlide>
					{cardsList.map(card => (
						<SwiperSlide data-hash={card.Id} key={card.Id}>
							<CardPage cardInfo={card} />
						</SwiperSlide>
					))}
					<SwiperSlide data-hash={'EmptyCard'} key={'EmptyCard'}>
						<div>СТРАНИЦА ПУСТОЙ КАРТЫ</div>
					</SwiperSlide>
				</Swiper>
			) : (
				<Wallet />
			)}

			<div className='ButtonToMenu-overlay'></div>

			<ButtonBar>
				<div className='MainPage__ButtonBar'>
					<AdaptiveButton onClick={goToAllWallets} icon='LIST_BULLET' />
					<ButtonToMenu openComponent={openComponent} closeComponent={closeComponent} showShadow />
				</div>
			</ButtonBar>
			<div className='MainPage__swiper-pagination' onClick={goToAllCards}></div>
		</div>
	);
};

export default MainPage;
